import styled from "styled-components";
import React, { Component } from "react";
import DOMPurify from "dompurify";
import { connect } from "react-redux";
import { addProduct } from "../../redux/features/cartSlice";
import { mapStateToProps } from "../../redux/store";
const ProductGallery = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
  @media screen and (min-width: 768px) {
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    max-width: 80px;
    gap: 2.5rem;
    margin-bottom: 0;
  }
`;
const ProductImage = styled.img`
  object-fit: contain;
  width: 80px;
  height: 80px;
  cursor: pointer;
  border: ${({ selectedImage, image }) =>
    selectedImage === image && "2px solid #5ECE7B"};
`;
const Image = styled.img``;
const SelectedImage = styled.div`
  margin-bottom: 2.5rem;
  position: relative;
  @media screen and (min-width: 768px) {
    flex: 3;
    margin-bottom: 0;
    margin-left: 20px;
    margin-right: 80px;
  }
  @media screen and (min-width: 1200px) {
    margin-left: 40px;
    margin-right: 100px;
  }
`;
const Out = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  color: #8d8f9a;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  text-align: center;
  font-size: 1.5rem;
  background-color: rgba(255, 255, 255, 0.5);
`;
const ProductDetails = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (min-width: 768px) {
    display: block;
    text-align: left;
    flex: 2;
  }
`;
const ProductName = styled.div`
  font-weight: 300;
  line-height: 160%;
  margin-bottom: 0.5rem;
  font-size: 1.875rem;
`;
const ProductBrand = styled.div`
  font-weight: 600;
`;
const ProductPrice = styled.div`
  font-family: "Roboto Condensed", sans-serif;
  margin-top: 2rem;
  font-size: 1.125rem;
`;
const Price = styled.div`
  margin-top: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
`;
const ProductAttribute = styled.div`
  margin: 1.5rem auto;
  font-size: 18px;
`;
const AttributeName = styled.div`
  margin-bottom: 0.5rem;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 700;
`;
const AttributeValues = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const AttributeValue = styled.div`
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  user-select: none;
  color: ${({ name, value, selectedAttributes }) =>
    selectedAttributes[name] === value ? "white" : "black"};
  background-color: ${({ color, name, value, selectedAttributes }) => {
    if (color) return color;
    else if (selectedAttributes[name] === value) return "black";
  }};
  border: ${({ name, value, type, selectedAttributes }) =>
    type !== "text" && selectedAttributes[name] === value
      ? "solid 2px #5ECE7B"
      : "solid 1px black"};
  height: ${({ color }) => (color ? "36px" : "45px")};
  width: ${({ color }) => (color ? "36px" : "64px")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;

  cursor: pointer;
`;
const Add = styled.button`
  font-size: 1rem;
  font-weight: 600;
  padding: 1rem 2rem;
  border: none;
  background-color: ${({ inStock, attributes }) =>
    inStock && attributes ? "#5ECE7B" : "rgba(94, 206, 123, 0.5)"};
  color: white;
  cursor: ${({ inStock, attributes }) =>
    inStock && attributes ? "pointer" : "default"};
  margin-bottom: 2.5rem;
`;
const Desc = styled.div`
  font-weight: 400;
`;

class ProductDescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: this.props.productDetails.gallery[0],
      selectedAttributes: {},
    };
  }
  componentDidMount() {
    document.title = this.props.productDetails.name;
  }
  render() {
    const { name, brand, gallery, inStock, attributes, prices } =
      this.props.productDetails;

    const { __typename, description, ...cartProduct } =
      this.props.productDetails;
    const selectedPrice = prices.find(
      (price) => price.currency.label === this.props.currencyState.label
    );
    return (
      <>
        <ProductGallery>
          {gallery.map((image) => (
            <ProductImage
              selectedImage={this.state.selectedImage}
              image={image}
              key={image}
              src={image}
              onClick={() => this.setState({ selectedImage: image })}
            />
          ))}
        </ProductGallery>
        <SelectedImage>
          <Image src={this.state.selectedImage} />
          {!inStock && <Out>OUT OF STOCK</Out>}
        </SelectedImage>
        <ProductDetails>
          <ProductName>
            <ProductBrand>{brand}</ProductBrand>
            {name}
          </ProductName>
          {attributes.map((attribute) => {
            if (attribute.type === "swatch")
              return (
                <ProductAttribute key={attribute.name}>
                  <AttributeName>{attribute.name}</AttributeName>
                  <AttributeValues>
                    {attribute.items.map((item) => (
                      <AttributeValue
                        key={item.value}
                        color={item.value}
                        name={attribute.name}
                        value={item.value}
                        type={attribute.type}
                        selectedAttributes={this.state.selectedAttributes}
                        onClick={() =>
                          this.setState({
                            selectedAttributes: {
                              ...this.state.selectedAttributes,
                              [attribute.name]: item.value,
                            },
                          })
                        }
                      />
                    ))}
                  </AttributeValues>
                </ProductAttribute>
              );
            else
              return (
                <ProductAttribute key={attribute.name}>
                  <AttributeName>{attribute.name}</AttributeName>
                  <AttributeValues>
                    {attribute.items.map((item) => (
                      <AttributeValue
                        key={item.value}
                        name={attribute.name}
                        value={item.value}
                        type={attribute.type}
                        selectedAttributes={this.state.selectedAttributes}
                        onClick={() =>
                          this.setState({
                            selectedAttributes: {
                              ...this.state.selectedAttributes,
                              [attribute.name]: item.value,
                            },
                          })
                        }
                      >
                        {item.value}
                      </AttributeValue>
                    ))}
                  </AttributeValues>
                </ProductAttribute>
              );
          })}
          <ProductPrice>PRICE</ProductPrice>
          <Price>
            {selectedPrice.currency.symbol}
            {selectedPrice.amount.toFixed(2)}
          </Price>

          <Add
            disabled={
              !inStock ||
              attributes.length !==
                Object.keys(this.state.selectedAttributes).length
            }
            inStock={inStock}
            attributes={
              attributes.length ===
              Object.keys(this.state.selectedAttributes).length
            }
            onClick={() =>
              this.props.dispatch(
                addProduct({
                  productDetails: {
                    ...cartProduct,
                    selectedAttributes: this.state.selectedAttributes,
                  },
                })
              )
            }
          >
            ADD TO CART
          </Add>
          <Desc
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(this.props.productDetails.description),
            }}
          />
        </ProductDetails>
      </>
    );
  }
}
export default connect(mapStateToProps)(ProductDescription);
